
import { defineComponent, ref, computed, nextTick } from 'vue'
import hljs from 'highlight.js'
import typescript from 'highlight.js/lib/languages/typescript'
import 'highlight.js/scss/dracula.scss'
hljs.registerLanguage('typecript', typescript)

export default defineComponent({
  props: {
    isThemeChanged: Boolean
  },
  setup () {
    const displayCode = ref('')
    const styledCode = computed(() => hljs.highlightAuto(`// Thank you for visiting.
// This is my portfolio site.

console.log('Hello Hackers!');

class Profile {
  private age?: number;
  constructor (readonly name: string, readonly gender: 'male' | 'female') {}

  getAge (this: Profile, birthYear: number) {
    const now = new Date();
    const thisYear = now.getFullYear();

    this.age = thisYear - birthYear;

    console.log(\`I am \${this.age} years old.\`)
  }
}

const me = new Profile(
  'Takeuchi Takuto',
  'male'
);

me.getAge(1993);

console.log('Nice to meet you!');
    `).value)
    const typingCode = () => [...styledCode.value].forEach((character, index) => setTimeout(() => displayCode.value += character, ++index * 10))

    nextTick(typingCode)

    return {
      displayCode
    }
  }
})
